import React from 'react';
import { FG140 } from '../../../services/g204Api';
import { dateToInput, inputToDate, fmt, isFieldDisabledFn, isApproved } from '../helpers';

interface Tab1HeaderProps {
  formData: Partial<FG140>;
  names: Record<string, string>;
  isEditing: boolean;
  getField: (key: keyof FG140) => FG140[keyof FG140];
  setField: (key: keyof FG140, value: FG140[keyof FG140]) => void;
  resolveSingleName: (nameKey: string, type: string, code: string) => void;
}

const Tab1Header: React.FC<Tab1HeaderProps> = React.memo(({
  formData, names, isEditing, getField, setField, resolveSingleName,
}) => {
  const approved = isApproved(formData as FG140);
  const totalAmount = (formData.fg140_14 || 0) + (formData.fg140_15 || 0);

  return (
    <div>
      {/* Header fields */}
      <div className="form-grid">
        <label data-contract-field="fg140_01">折讓單號</label>
        <input
          type="text"
          value={String(getField('fg140_01') || '')}
          disabled
          readOnly
          style={{ maxWidth: 120 }}
        />

        {approved && (
          <span style={{
            color: '#ff0000', fontWeight: 'bold', fontSize: 14,
            padding: '2px 8px', background: '#fff1f0', borderRadius: 4,
            border: '1px solid #ffa39e',
          }}>
            已核准
          </span>
        )}
        {!approved && <span />}

        <label data-contract-field="fg140_11">折讓日期</label>
        <input
          type="date"
          value={dateToInput(getField('fg140_11') as string | null)}
          onChange={e => setField('fg140_11', inputToDate(e.target.value) as unknown as FG140[keyof FG140])}
          disabled={isFieldDisabledFn('fg140_11', isEditing)}
          style={{ maxWidth: 160 }}
        />

        <span />

        <label className="required" data-contract-field="fg140_12">公司代號</label>
        <div className="lookup-field">
          <input
            type="text"
            value={String(getField('fg140_12') || '')}
            onChange={e => setField('fg140_12', e.target.value as FG140[keyof FG140])}
            onBlur={() => resolveSingleName('customer', 'customer', String(getField('fg140_12') || ''))}
            onDoubleClick={() => {
              if (!isFieldDisabledFn('fg140_12', isEditing)) {
                window.open(`#/erp/lookup/customer`, '_blank');
              }
            }}
            disabled={isFieldDisabledFn('fg140_12', isEditing)}
            style={{ maxWidth: 140, cursor: isEditing ? 'pointer' : undefined }}
            title={isEditing ? '雙擊開啟客戶查詢' : ''}
          />
          <span className="lookup-name">{names.customer || ''}</span>
        </div>

        <label data-contract-field="fg140_13">公司名稱</label>
        <input
          type="text"
          value={String(getField('fg140_13') || '')}
          disabled
          readOnly
          style={{ gridColumn: 'span 3', background: '#f5f5f5' }}
        />

        <label data-contract-field="fg140_19">備註</label>
        <input
          type="text"
          value={String(getField('fg140_19') || '')}
          onChange={e => setField('fg140_19', e.target.value as FG140[keyof FG140])}
          disabled={isFieldDisabledFn('fg140_19', isEditing)}
          style={{ gridColumn: 'span 3' }}
        />

        <label data-contract-field="fg140_16">幣別</label>
        <input
          type="text"
          value={String(getField('fg140_16') || '')}
          onChange={e => setField('fg140_16', e.target.value as FG140[keyof FG140])}
          onBlur={() => resolveSingleName('currency', 'currency', String(getField('fg140_16') || ''))}
          disabled={isFieldDisabledFn('fg140_16', isEditing)}
          style={{ maxWidth: 80 }}
        />
        <span className="lookup-name" style={{ fontSize: 12, color: '#888' }}>{names.currency || ''}</span>
      </div>

      {/* Summary row */}
      <div style={{ display: 'flex', gap: 24, marginTop: 12, padding: '8px 12px', background: '#f5f5f5', borderRadius: 4 }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
          <label style={{ fontSize: 13, color: '#666' }} data-contract-field="fg140_14">折讓總淨額</label>
          <span style={{ fontWeight: 500, fontVariantNumeric: 'tabular-nums' }}>{fmt(formData.fg140_14)}</span>
        </div>
        <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
          <label style={{ fontSize: 13, color: '#666' }} data-contract-field="fg140_15">折讓總稅額</label>
          <span style={{ fontWeight: 500, fontVariantNumeric: 'tabular-nums' }}>{fmt(formData.fg140_15)}</span>
        </div>
        <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
          <label style={{ fontSize: 13, color: '#666', fontWeight: 600 }} data-contract-field="ui_total_amount">折讓總金額</label>
          <span style={{ fontWeight: 600, fontSize: 15, color: '#1890ff', fontVariantNumeric: 'tabular-nums' }}>
            {fmt(totalAmount)}
          </span>
        </div>
        <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
          <label style={{ fontSize: 13, color: '#666' }} data-contract-field="fg140_18">總項數</label>
          <span style={{ fontWeight: 500 }}>{formData.fg140_18 || 0}</span>
        </div>
      </div>
    </div>
  );
});

Tab1Header.displayName = 'Tab1Header';
export default Tab1Header;
